import { render, staticRenderFns } from "./ThemeSettingList.vue?vue&type=template&id=56105a6a"
import script from "./ThemeSettingList.vue?vue&type=script&lang=js"
export * from "./ThemeSettingList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports